import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const BarChartTaxa = ({ data, width = 800, height = 500 }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!data || data.length === 0) return;

        const margin = { top: 20, right: 30, bottom: 80, left: 60 };
        const innerWidth = width - margin.left - margin.right;
        const innerHeight = height - margin.top - margin.bottom;

        d3.select(svgRef.current).selectAll("*").remove();

        const svg = d3.select(svgRef.current)
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        const taxa = data[0].sortedTaxa.map(d => d.name);
        const samples = data.map(d => d.sampleId);

        const groupedData = taxa.map(taxon => {
            const obj = { taxon };
            samples.forEach(sample => {
                const sampleData = data.find(d => d.sampleId === sample);
                const taxonData = sampleData.sortedTaxa.find(d => d.name === taxon);
                obj[sample] = taxonData ? taxonData.abundance * 100 : 0;
            });
            return obj;
        });

        const x0 = d3.scaleBand()
            .domain(taxa)
            .rangeRound([0, innerWidth])
            .paddingInner(0.1);

        const x1 = d3.scaleBand()
            .domain(samples)
            .rangeRound([0, x0.bandwidth()])
            .padding(0.05);

        const y = d3.scaleLinear()
            .domain([0, d3.max(groupedData, d => d3.max(samples, sample => d[sample]))])
            .nice()
            .rangeRound([innerHeight, 0]);

        const color = d3.scaleOrdinal()
            .domain(samples)
            // .range(d3.schemeObservable10);
            // .range(d3.schemeSpectral[10]);
            .range(d3.schemeSpectral[data.length]);

        // x-axis
        svg.append("g")
            .attr("transform", `translate(0,${innerHeight})`)
            .call(d3.axisBottom(x0))
            .attr("color", "white")
            .attr("font-family", "Arial")
            .attr("font-size", 12)
            .selectAll("text")
            .attr("transform", "rotate(-45)")
            .style("text-anchor", "end")
            .style("fill", "white");

        // y-axis
        svg.append("g")
            .call(d3.axisLeft(y).ticks(null, "s").tickFormat(d => `${d}%`))
            .attr("color", "white")
            .attr("font-family", "Arial")
            .attr("font-size", 12)
            .selectAll("text")
            .style("fill", "white");

        // bars
        svg.append("g")
            .selectAll("g")
            .data(groupedData)
            .join("g")
            .attr("transform", d => `translate(${x0(d.taxon)},0)`)
            .selectAll("rect")
            .data(d => samples.map(key => ({ key, value: d[key] })))
            .join("rect")
            .attr("x", d => x1(d.key))
            .attr("y", d => y(d.value))
            .attr("width", x1.bandwidth())
            .attr("height", d => innerHeight - y(d.value))
            .attr("fill", d => color(d.key));

        // legend
        const legend = svg.append("g")
            .attr("text-anchor", "end")
            .selectAll("g")
            .data(samples)
            .join("g")
            .attr("transform", (d, i) => `translate(0,${i * 20})`);

        legend.append("rect")
            .attr("x", innerWidth - 19)
            .attr("width", 19)
            .attr("height", 19)
            .attr("fill", color);

        legend.append("text")
            .attr("x", innerWidth - 24)
            .attr("y", 9.5)
            .attr("dy", "0.32em")
            .attr("font-family", "Arial")
            .attr("font-size", 12)
            .text(d => d)
            .style("fill", "white")
            ;

        // x-axis label
        svg.append("text")
            .attr("transform", `translate(${innerWidth / 2},${innerHeight + margin.bottom})`)
            .attr("font-family", "Arial")
            .attr("font-size", 12)
            .style("text-anchor", "middle")
            .text("Taxa")
            .style("fill", "white");

        // y-axis label
        svg.append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - margin.left)
            .attr("x", 0 - (innerHeight / 2))
            .attr("dy", "1em")
            .attr("font-family", "Arial")
            .attr("font-size", 12)
            .style("text-anchor", "middle")
            .text("Abundance (%)")
            .style("fill", "white");


    }, [data, width, height]);

    return <svg ref={svgRef} style={{ overflow: "visible" }}></svg>;
};

export default BarChartTaxa;